import { FormField, Heading, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { InputWidth } from '../../../../types/aoraki/input-width-types'
import { WellheadSecuritySubFormProps } from './well-head-security-view-quality'

export default function WellheadSecurityViewSurroundingArea({ isLoading, fields }: WellheadSecuritySubFormProps) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Surrounding area
      </Heading>

      <FormField
        toolTipMessage={TOOLTIP.wellheadCovering}
        isSkeleton={isLoading}
        labelId='wellheadCovering'
        label='Covering over wellhead'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='wellheadCovering' value={fields?.wellheadCovering ?? ''} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.coveringSecure}
        isSkeleton={isLoading}
        labelId='coveringSecure'
        label='Covering secure'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='coveringSecure' value={fields?.coveringSecure ?? ''} />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='fenceAroundWellhead' label='Fence around wellhead (5m radius)'>
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='fenceAroundWellhead'
          value={fields?.isWellHeadFenced ?? ''}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.stockAccess}
        isSkeleton={isLoading}
        labelId='stockAccess'
        label='Stock access to wellhead'
      >
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='stockAccess'
          value={fields?.stockAccess ?? ''}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.wellheadTopography}
        isSkeleton={isLoading}
        labelId='wellheadTopography'
        label='Topography around wellhead'
      >
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='wellheadTopography'
          value={fields?.wellheadTopography ?? ''}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='septicTankPresent' label='Septic tank on property'>
        <ReadOnlyField
          fieldSize={InputWidth.medium}
          isSkeleton={isLoading}
          labelledBy='septicTankPresent'
          value={fields?.septicTankPresent ?? ''}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='distanceSepticTank' label='Distance to nearest septic tank (m)'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='distanceSepticTank'
          value={fields?.distanceToNearestSepticTank}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.wellheadHazards}
        isSkeleton={isLoading}
        labelId='hazardsAroundWellhead'
        label='Hazards around wellhead'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='hazardsAroundWellhead' value={fields?.wellheadHazards} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.surroundingLanduse}
        isSkeleton={isLoading}
        labelId='surroundingLanduse'
        label='Surrounding landuse'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='surroundingLanduse' value={fields?.surroundingLanduse} />
      </FormField>
    </>
  )
}
